/**
 * @generated SignedSource<<261a61618a0ffcf2e97cd028043dd686>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StartedAtColumn_ContentSubmissionFragment$data = {
  readonly startedAt: string;
  readonly " $fragmentType": "StartedAtColumn_ContentSubmissionFragment";
};
export type StartedAtColumn_ContentSubmissionFragment$key = {
  readonly " $data"?: StartedAtColumn_ContentSubmissionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"StartedAtColumn_ContentSubmissionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StartedAtColumn_ContentSubmissionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startedAt",
      "storageKey": null
    }
  ],
  "type": "ContentSubmission",
  "abstractKey": null
};

(node as any).hash = "23a7ee9e209cf7998ad8970039452e51";

export default node;
